import styled, { css } from 'styled-components';
import { getColor, Fonts, StyleVars } from 'core/utils/Styles';
import Crt  from './Caret';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	& + & {
		margin: 30px 0px;
	}
`;

export const Trigger = styled.label`
	margin: 0;
	padding: 0;
	padding-right: 20px;
	margin-right: -20px;
	display: flex;
	align-items: center;
`;

export const CategoryName = styled.h6`
	font-family: ${Fonts.serif};
	margin: 0;
	font-size: 19px;
	line-height: 20px;
	letter-spacing: 0.2px;
	margin-right: auto;
`;

export const IconWrapper = styled.div`
	margin-right: 16px;
	svg {
		display: block;
		width: 36px;
		height: 32px;
	}
`;

export const Caret = styled(Crt)`
	cursor: pointer;
	transform-origin: center;
	transform: rotate(-90deg);
	transition: transform 0.2s;
`;

export const SubCat = styled.a`
	font-family: ${Fonts.serif};
	display: block;
	font-size: 16px;
	line-height: 40px;
	letter-spacing: 0.2px;
	color: inherit;
	text-decoration: ${(props) => props.underline ? `underline` : `none`};
	font-weight: normal;

	@media (min-width: ${StyleVars.screenSm}) {
		/* left rail styles for desktop categorybranch */
		line-height: 1.5;
		margin-bottom: 12px;
	}

	&:hover, &:focus {
		text-decoration: ${(props) => props.underline ? `underline` : `none`};
		color: ${getColor('darkTeal')};
	}

	${props => props.highlight && css`
		font-weight: 600;
	`}
`;

export const CategoryLink = styled.a`
	margin: 0;
	padding: 0;
	display: flex;
	align-items: center;
	width: calc(100% - 44px);
	margin-right: auto;
	color: inherit;

	@media (min-width: ${StyleVars.screenSm}) {
		padding-bottom: 24px;
		border-bottom: 1px solid ${getColor('alto')};
		width: 100%;
	}
`;

export const AllLink = styled(SubCat)`
	color: ${getColor('darkTeal')};
	font-weight: 700;
`;

export const HiddenCheck = styled.input.attrs({
	type: 'checkbox'
})`
	display: none;
	&:checked + ${Trigger} {
		${Caret} {
			transform: rotate(0);
		}
	}
`;

export const SubCatsContainer = styled.div`
	overflow: hidden;
	height: 0;
	transition: 0.2s;
	border-bottom: 1px solid transparent;

	/* stylelint-disable */
	${HiddenCheck}:checked + * + & {
		padding: 18px 0;
		flex: 2;
		overflow-y: auto;
		border-bottom-color: ${getColor('alto')};
	}

	${({ sidebar }) => sidebar && css`
		border-bottom: 0 none;
		height: auto;

		${HiddenCheck}:checked + * + & {
			padding-bottom: 0;
		}
	`}
	/* stylelint-enable */
`;

export const SubCats = styled.div`
	overflow: hidden;
	height: 0;
	transition: max-height 0.2s ease-in;
	padding: 0 0 0 42px;

	/* stylelint-disable */
	${HiddenCheck}:checked + * + & {
		height: ${({ totalHeight }) => totalHeight };
		border-bottom-color: ${getColor('alto')};
	}

	@media (min-width: ${StyleVars.screenSm}) {
		height: auto;
		max-height: 0;
		padding: 0 0 0 16px;

		${HiddenCheck}:checked + * + & {
			/* animate the max-height on desktop */
			height: auto;
			max-height: ${({ totalHeight }) => `calc(${totalHeight} + ${totalHeight})` };
		}
	}
	/* stylelint-enable */
`;

export const SectionTitle = styled.h6`
	color: inherit;
	font-family: ${Fonts.base};
	font-weight: 600;
	margin: 0;
	font-size: 17px;
	line-height: 40px;
	letter-spacing: 0.2px;
	margin-right: auto;
	text-decoration: ${(props) => props.underline ? `underline` : `none`};
`;
